/**
 * Provides auth services to the app, including:
 * * Bearer token support for all REST calls
 * * Logout capabilities
 * * TODO: Route guarding based on user permissions/scope?
 */
export function initHttpAuth ({ $services, config }) {
  const $http = $services.resolve('http');

  // Instruct the http service to pass along a bearer token with each request.
  $http.interceptors.request.use(addBearerToken, onError);

  function addBearerToken (requestConfig) {
    const token = config.bearerToken;

    if (token !== null) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    return requestConfig;
  }

  function onError (err) {
    // Normally in OAuth2 we'd check for a 401 response and attempt to get a new token if we get one, but since
    // we're not using refresh tokens right now we're not going to bother with that and just fail the request.
    return Promise.reject(err);
  }
}
